import React, {useEffect} from 'react'
import {Tabs} from "antd";
import {BackIcon} from '../../../asset';
import {t} from "i18next";
import style from "./userPage.module.css"
import PrimaryButton from '../../../component/button/PrimaryButton';
import SecondaryButton from '../../../component/button/SecondaryButton';
import {useUser} from './UserPage.hooks';
import {useLocation} from 'react-router-dom';
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import DeleteConfirmationModal from '../../../component/modal/DeleteConfirmationModal';
import SuccessModal from '../../../component/modal/SuccessModal';
import ManagementHistory from "../../../component/management-history/management-history";


export default function UserDetail() {

    const {state} = useLocation();

    const {
        toUserList,
        userManagementOpen,
        setUserManagementOpen,
        detailUser,
        doGetDetailUser,
        convertTimestamp,
        toEdit,
        id,
        deleteConfirmationModalOpen,
        setDeleteConfirmationModalOpen,
        selectedUpdatedAt,
        selectedUserId,
        selectedUserName,
        successModalOpen,
        setSelectedUserId,
        setSelectedUpdatedAt,
        setSelectedUserName,
        doDeleteUser
    } = useUser()

    useEffect(() => {
        doGetDetailUser(state.id)
        // eslint-disable-next-line
    }, []);

    const items = [
        {
            key: 1,
            label: t("USER_DETAIL:USER_PROFILE"),
            children: <UserProfileTab data={detailUser}/>,
        },
        {
            key: 2,
            label: t("USER_DETAIL:ACCESS_SETTING"),
            children: <AccessSettingTab data={detailUser}/>,
        },
    ];

    function deleteData(id, updated_at, user_name) {
        setSelectedUserId(id)
        setSelectedUpdatedAt(updated_at)
        setSelectedUserName(user_name)
        // doDeleteVehicle(id, updated_at)
        setDeleteConfirmationModalOpen(true)
    }

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <DeleteConfirmationModal
                isOpen={deleteConfirmationModalOpen}
                onOk={() => setDeleteConfirmationModalOpen(false)}
                onCancel={() => doDeleteUser(selectedUserId, selectedUpdatedAt)}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Cancel"
                cancelText="Yes, Delete"
                title="Delete Data?"
                description={<p>Are you sure want to delete <br/> <strong>{selectedUserId} - {selectedUserName}</strong>
                </p>}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => toUserList()}
                closable={false}
                width={280}
                className={style.deleteModal}
                okText="Ok"
                title="Well Done"
                description="Your data has been deleted"
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Admin`}
                menuLevel2={`User Management`}
                menuLevel3={`User`}
                menuLevel4={`Detail ${detailUser?.grochat_account_information.username}`}
            />

            <div className='flex items-center justify-between'>
                <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => toUserList()}>
                    <img src={BackIcon} alt=""/>
                    <h1 className='font-sans-bold text-2xl'
                        id='title'>{`Detail ${detailUser?.grochat_account_information.username}`}</h1>
                </div>

                <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer'
                     onClick={() => setUserManagementOpen(true)}>
                    <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")} {" "}
                        <strong>{detailUser?.created_by_name}</strong> {t("USER_DETAIL:ON")} {" "}
                        <strong>{convertTimestamp(detailUser?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} {" "}
                        <strong>{detailUser?.updated_by_name}</strong> {t("USER_DETAIL:ON")} {" "}
                        <strong>{convertTimestamp(detailUser?.updated_at, true)}</strong></p>
                </div>
            </div>

            <div
                className={style.tabsContainer + " bg-[#FFFFFF] border-[1px] border-[#DDDDDD] px-[30px] py-[24px] rounded-[10px]"}>
                <Tabs defaultActiveKey='1' items={items}/>
            </div>

            <div className='flex flex-row-reverse gap-[16px]'>
                <PrimaryButton text={t("USER_DETAIL:EDIT")} action={() => {
                    toEdit(id)
                }}/>
                <SecondaryButton text={t("USER_DETAIL:DELETE")}
                                 action={() => deleteData(state.id, detailUser?.updated_at, detailUser?.grochat_account_information.username)}/>
            </div>

            <ManagementHistory
                id={detailUser?.person_profile_id}
                detail={detailUser}
                tableName={'person_profile'}
                userManagementOpen={userManagementOpen}
                setUserManagementOpen={() => setUserManagementOpen(false)}
            />

        </div>
    )
}

function UserProfileTab(data) {
    return (
        <div className='flex flex-col gap-[40px]'>
            <div>
                <h3 className='font-roboto text-[20px] font-bold'>{t("USER_DETAIL:GROCHAT_ACCOUNT_INFORMATION")}</h3>
                <p className='mb-[16px] font-roboto text-[16px]'>{t("USER_DETAIL:EDIT_DESCRIPTION")}</p>
                <div className='flex gap-[40px] mb-[16px]'>
                    <div className="w-[350px]">
                        <label
                            className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:USERNAME_FIELD")}</label>
                        <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grochat_account_information.username}</h4>
                    </div>
                    <div className="w-[350px]">
                        <label className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:PHONE_FIELD")}</label>
                        <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grochat_account_information.phone}</h4>
                    </div>
                    <div className="w-[350px]">
                        <label className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:TITLE_FIELD")}</label>
                        <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grochat_account_information.title}</h4>
                    </div>
                </div>
                <div className='flex gap-[40px]'>
                    <div className="w-[350px]">
                        <label
                            className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:GENDER_FIELD")}</label>
                        <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grochat_account_information.gender === "L" ? "Male" : "Female"}</h4>
                    </div>
                    <div className="w-[350px]">
                        <label
                            className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:FIRST_NAME_FIELD")}</label>
                        <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grochat_account_information.first_name}</h4>
                    </div>
                    <div className="w-[350px]">
                        <label
                            className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:LAST_NAME_FIELD")}</label>
                        <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grochat_account_information.last_name}</h4>
                    </div>
                </div>
            </div>
            <div>
                <h3 className='font-roboto text-[20px] font-bold mb-[16px]'>{t("USER_DETAIL:GROLOG_ACCOUNT_INFORMATION")}</h3>
                <div>
                    <h4 className='font-roboto-medium text-[18px] text-[#000000] mb-[16px]'>{t("USER_DETAIL:PERSONAL_INFORMATION")}</h4>
                    <div className='flex gap-[40px] mb-[16px]'>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:EMAIL_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.email}</h4>
                        </div>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:NIK_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.nik}</h4>
                        </div>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:BIRTH_PLACE_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.birth_place}</h4>
                        </div>
                    </div>
                    <div className="w-[350px] mb-[16px]">
                        <label
                            className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:BIRTH_DATE_FIELD")}</label>
                        <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.birth_day}</h4>
                    </div>
                </div>
                <div>
                    <h4 className='mb-[16px]'>{t("USER_DETAIL:ADDRESS_INFORMATION")}</h4>
                    <div className='flex gap-[40px] mb-[16px]'>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:COUNTRY_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.country}</h4>
                        </div>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:PROVINCE_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.province}</h4>
                        </div>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:DISTRICT_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.district}</h4>
                        </div>
                    </div>
                    <div className='flex gap-[40px] mb-[16px]'>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:SUB_DISTRICT_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.sub_district}</h4>
                        </div>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:URBAN_VILLAGE_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.urban_village}</h4>
                        </div>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:ADDRESS_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.address}</h4>
                        </div>
                    </div>
                    <div className='flex gap-[40px] mb-[16px]'>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:NEIGHBOURHOOD_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.neighbourhood}</h4>
                        </div>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:HAMLET_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.hamlet}</h4>
                        </div>
                        <div className="w-[350px]">
                            <label
                                className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:POSTAL_CODE_FIELD")}</label>
                            <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_account_information.postal_code}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function AccessSettingTab(data) {
    return (
        <div className='flex flex-col gap-[40px]'>
            <div className='flex gap-[40px] mb-[16px]'>
                <div className="w-[350px]">
                    <label
                        className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:GROLOG_ACCOUNT_FIELD")}</label>
                    <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_access_setting.grolog_account}</h4>
                </div>
                <div className="w-[350px]">
                    <label className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:ROLE_FIELD")}</label>
                    <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_access_setting.role}</h4>
                </div>
                <div className="w-[350px]">
                    <label
                        className='font-roboto text-[14px] text-[#818181]'>{t("USER_DETAIL:DATA_GROUP_FIELD")}</label>
                    <h4 className='font-roboto text-[20px] text-[#424242]'>{data.data?.grolog_access_setting.data_group}</h4>
                </div>
            </div>
        </div>
    )
}